export default __webpack_public_path__ + "static/media/500-oops-kid.f41ce033.png";